import { PortalEventContextType } from "../../../autogen/bff-api";

export const isInvitedCompetition = (contextType: PortalEventContextType): boolean =>
  contextType === PortalEventContextType.Private || contextType === PortalEventContextType.MiniCompetition;
